"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionCategoryTypeEnum = void 0;
var OptionCategoryTypeEnum;
(function (OptionCategoryTypeEnum) {
    OptionCategoryTypeEnum["INCIDENT"] = "incident";
})(OptionCategoryTypeEnum || (exports.OptionCategoryTypeEnum = OptionCategoryTypeEnum = {}));
